export default __webpack_public_path__ + "static/media/unsynced_xero_icon.959eaa04.png";